import React from "react";
import Spacer from "../../../components/spacer";
import UserList from "./UserList";

const UsersModule = () => {
	return (
		<div className="content-wrapper">
			<Spacer size="30" />
			<UserList />
			<Spacer size="90" />
		</div>
	);
};

export default UsersModule;
